import React, { useState, useEffect, useRef } from "react";
import { motion, useSpring, useTransform, useViewportScroll } from 'framer-motion';
import CSGoogleImage from "../../images/Google-device.png";
import CSEBMobileImage1 from "../../images/iPhone-Screen.png";
import InView from "react-intersection-observer";
import Parallax from "../common/utils/animations/parallax";

export default function KrogerCsEbusiness(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 300;
  const easing = [0.42, 0, 0.58, 1];
  const ref = useRef();

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    //console.log('setting values in mobile intro: ', ref.current.offsetTop);
    setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const y0 = useSpring(useTransform(scrollY, [elementTop - clientHeight * 0.9, elementTop - clientHeight / 6], [yOffset, 0], easing), { damping: 50, stiffness: 500 });
  const y1 = useTransform(scrollY, [elementBottom - clientHeight * 0.9, elementBottom - clientHeight / 6], [yOffset, 0], easing);
  const variants = {
    hidden: {
      scale: 0,
      opacity: 0
    },
    show: {
      scale: 1,
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: [0.42, 0, 0.58, 1],
        duration: 0.3
      },
    }
  };
  return (
    <div ref={ref} className="cs-mobile-intro-section section-gap" onLoad={setValues}>
      <div className="mobile-intro-top">
        <div className="mobile-top-img">
          <Parallax id="retail-data-analytics-top-img" triggers={[1, 0.4]} length={100}>
            <motion.img src={CSGoogleImage} alt="retail data analytics" title="Data Analytics In Retail" />
          </Parallax>
        </div>
        <InView as="div" className="container" onChange={(inView) => setIsVisible(inView)} triggerOnce>
          <div className="chip">
            <motion.ul
              initial="hidden"
              animate={isVisible ? "show" : "hidden"}
              variants={variants}
              className="chipset">
              <motion.li variants={variants}>APIs</motion.li>
              <motion.li variants={variants}>Interaction Engine</motion.li>
              <motion.li variants={variants}>Security</motion.li>
              <motion.li variants={variants}>Data Analytics</motion.li>
              <motion.li variants={variants}>Personalization</motion.li>
              <motion.li variants={variants}>NLP</motion.li>
            </motion.ul>
          </div>
          <h5>CORE PLATFORM FUNCTIIONS</h5>
        </InView>
      </div>
      <div className="container">
        <div className="row d-flex flex-wrap section-gap mobile-intro-middle justify-center">
          <div className="col">
            <h3>Enabling natural conversations</h3>
            <p>We strived to build a voice assistant that feels as natural as a casual conversation between two people. Hence, the assistant needs to understand the spoken language and converse within context.</p>

            <p>To design the interactions, we mapped out the end-to-end shopping journey as a series of natural conversations that a customer would expect to have with a person. We found that variants, words, tones, and commands differed between user personas, and we built our research into a trained NLP service. The result was astonishingly delightful — natural two-way interactions filled with context, intelligence, and human touch.</p>
          </div>
        </div>

        <div className="row d-flex flex-wrap mobile-intro-bottom">
          <div className="col">
            <h3>Just like having a personal shopper in the kitchen </h3>
            <p>When the customer asks the assistant to order “milk”, it knows which brand, type, and size you prefer and orders it for you.</p>
          </div>
          <div className="col text-center">
            <Parallax id="Google-Assistant-Order" triggers={[1, 0.7]} opacity={true} length={100}>
              <motion.img src={CSEBMobileImage1} alt="Order using Google Assistant" title="Google Assistant Order" />
            </Parallax>
          </div>
        </div>
      </div>
    </div>
  );
}